import { Box } from "@mantine/core";

interface Props {
  showId: string;
}

export function CaptivateEmbed({ showId }: Props) {
  return (
    <Box
      style={{
        position: "relative",
        width: "100%",
        borderRadius: 8,
        overflow: "hidden",
        background: "#1a1a1a",
      }}
    >
      <iframe
        title="Captivate podcast episode"
        src={`https://player.captivate.fm/episode/${showId}`}
        style={{
          width: "100%",
          height: 200,
          border: 0,
        }}
        loading="lazy"
      />
    </Box>
  );
}

export default CaptivateEmbed;
